import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainAuthGuard } from '../../_shared/guards/main-auth-guard.service';
import { MainPermissionGuard } from '../../_shared/guards/main-permission-guard.service';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { UserEditorComponent } from './user-editor/user-editor.component';
import { UserListComponent } from './user-list/user-list.component';

const routes: Routes = [
  {
    path:     'users',
    children: [
      {
        path:        '',
        canActivate: [MainAuthGuard, MainPermissionGuard],
        component:   UserListComponent,
        data:        {type: 'admin-user-list'},
      },
      {path: 'create', canActivate: [MainPermissionGuard], component: UserEditorComponent},
      {path: ':id/edit', canActivate: [MainPermissionGuard], component: UserEditorComponent},
      {path: ':id', canActivate: [MainPermissionGuard], component: UserDetailComponent},
    ],
  },
  {
    path:        'employee-list',
    canActivate: [MainAuthGuard],
    component:   UserListComponent,
    data:        {type: 'admin-employee-list'},
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})
export class UserRoutingModule {
}
